export interface PaletteInterface {
  main: {
    primary: string
    secondary: string
    tertiary: string
    quaternary: string
  }
  neutral: {
    black: string
    medium: string
    light: string
    white: string
  }
  hover: {
    primary: string
    medium: string
    success: string
    light: string
  }
  support: {
    success: string
    warning: string
    error: string
  }
}

export const palette: PaletteInterface = {
  hover: {
    light: '#f5f5f5',
    medium: '#353535',
    primary: '#1b4ea0',
    success: '#077117',
  },
  main: {
    primary: '#2770e5',
    quaternary: '#f3f6fb',
    secondary: '#e5253d',
    tertiary: '#f88795',
  },
  neutral: {
    black: '#000000',
    light: '#9d9d9d',
    medium: '#4d4d4d',
    white: '#ffffff',
  },
  support: {
    error: '#a0192a',
    success: '#2cac40',
    warning: '#e58221',
  },
}
